import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-approve-publish-dialog',
    templateUrl: './approve-publish-dialog.component.html',
    styleUrls: ['./approve-publish-dialog.component.css'],
    standalone: false,
})
export class ApprovePublishDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            version: string;
            userName: string;
        },
        private dialogRef: MatDialogRef<ApprovePublishDialogComponent>
    ) {}

    cancel() {
        this.dialogRef.close();
    }

    acceptPublish() {
        this.dialogRef.close(true);
    }
}
